export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-medicine-bottle-line',
      color: 'text-primary-500',
      bg: 'bg-primary-500/10',
      title: 'Know medication has been taken',
      desc: 'Track doses with reminders and confirmation so families never wonder if a pill was missed.',
    },
    {
      icon: 'ri-calendar-check-line',
      color: 'text-secondary-500',
      bg: 'bg-secondary-500/10',
      title: 'Reduce missed appointments',
      desc: 'Smart reminders for doctor visits, check-ups, and therapy sessions keep everyone on schedule.',
    },
    {
      icon: 'ri-group-line',
      color: 'text-accent-500',
      bg: 'bg-accent-500/10',
      title: 'Coordinate family visits',
      desc: 'Plan and share visit schedules so no one overlaps or forgets, and your loved one sees everyone regularly.',
    },
    {
      icon: 'ri-chat-heart-line',
      color: 'text-accent-400',
      bg: 'bg-accent-400/10',
      title: 'Keep everyone informed',
      desc: 'Updates, notes, and alerts in one shared place — no more scattered phone calls and text messages.',
    },
    {
      icon: 'ri-alarm-warning-line',
      color: 'text-primary-500',
      bg: 'bg-primary-500/10',
      title: 'Respond faster in emergencies',
      desc: 'One-touch SOS alerts instantly notify family and emergency contacts with location and key information.',
    },
    {
      icon: 'ri-home-smile-line',
      color: 'text-secondary-500',
      bg: 'bg-secondary-500/10',
      title: 'Support independent living',
      desc: 'Gentle reminders and simple tools help elderly parents stay in their own homes with confidence.',
    },
    {
      icon: 'ri-heart-pulse-line',
      color: 'text-accent-500',
      bg: 'bg-accent-500/10',
      title: 'Give families peace of mind',
      desc: 'See that your loved one is safe, cared for, and connected — even when you are miles away.',
    },
  ];

  return (
    <section id="benefits" className="bg-white py-16 md:py-24 px-4 md:px-8 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 mb-4">
            Less worry. Better communication. Safer care.
          </h2>
          <p className="text-base md:text-lg text-foreground-600/80 max-w-2xl mx-auto leading-relaxed">
            CareBridge turns the chaos of family care into a calm, connected routine. Here is what families gain.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {benefits.map((benefit, idx) => (
            <div
              key={idx}
              className="bg-background-200/70 rounded-xl p-6 border border-background-200/70 hover:shadow-md transition-all duration-300 group cursor-pointer"
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-lg ${benefit.bg} mb-4`}>
                <i className={`${benefit.icon} ${benefit.color} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                {benefit.title}
              </h3>
              <p className="text-sm text-foreground-600/80 leading-relaxed">
                {benefit.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}